import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function TransactionsPat() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState('all'); // all, repas, bus

  // Utilisation de la configuration centralisée
  const API_BASE = config.apiBase;

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE}/pat/get_transactions_jour.php`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) {
        setTransactions(data.transactions);
        setTotal(data.total_jour);
      }
    } catch (error) {
      toast.error('Erreur de chargement');
    } finally {
      setLoading(false);
    }
  };

  const filteredTransactions = transactions.filter(t => {
    if (filter === 'all') return true;
    if (filter === 'repas') return t.type === 'debit_repas';
    if (filter === 'bus') return t.type === 'debit_bus';
    return true;
  });

  const getTypeLabel = (type) => {
    if (type === 'debit_repas') return { text: 'Repas', color: 'bg-orange-100 text-orange-700' };
    if (type === 'debit_bus') return { text: 'Bus', color: 'bg-blue-100 text-blue-700' };
    if (type === 'recharge') return { text: 'Recharge', color: 'bg-green-100 text-green-700' };
    return { text: type, color: 'bg-gray-100 text-gray-700' };
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">📜 Historique des transactions</h1>
      <p className="text-gray-500 mb-6">Consultez toutes vos transactions</p>

      {/* Statistiques */}
      <div className="bg-white rounded-xl shadow-md p-6 mb-6">
        <div className="flex justify-between items-center">
          <div>
            <p className="text-gray-500 text-sm">Total des transactions</p>
            <p className="text-2xl font-bold text-primary">{transactions.length}</p>
          </div>
          <div className="text-right">
            <p className="text-gray-500 text-sm">Montant total débité</p>
            <p className="text-2xl font-bold text-green-600">{total.toLocaleString()} FCFA</p>
          </div>
        </div>
      </div>

      {/* Filtres */}
      <div className="flex gap-3 mb-6">
        <button
          onClick={() => setFilter('all')}
          className={`px-4 py-2 rounded-lg transition ${filter === 'all' ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
        >
          Toutes
        </button>
        <button
          onClick={() => setFilter('repas')}
          className={`px-4 py-2 rounded-lg transition ${filter === 'repas' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
        >
          Repas
        </button>
        <button
          onClick={() => setFilter('bus')}
          className={`px-4 py-2 rounded-lg transition ${filter === 'bus' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
        >
          Bus
        </button>
      </div>

      {/* Liste des transactions */}
      {filteredTransactions.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-12 text-center">
          <p className="text-gray-400">Aucune transaction trouvée</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-50 border-b">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Étudiant</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Montant</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {filteredTransactions.map((t, index) => {
                const typeInfo = getTypeLabel(t.type);
                return (
                  <tr key={index} className="hover:bg-gray-50 transition">
                    <td className="px-6 py-4">
                      <span className="font-medium">{t.etudiant_prenom} {t.etudiant_nom}</span>
                    </td>
                    <td className="px-6 py-4">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${typeInfo.color}`}>
                        {typeInfo.text}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="font-semibold text-green-600">{t.montant} FCFA</span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500">
                      {new Date(t.date_heure).toLocaleString()}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}